import { Component, OnInit } from '@angular/core';
import { InteractService } from 'app/BaseFramework/core/services';
import { MultiTenancyConfigService } from '../../services/multi-tenancy-config.service';

@Component({
  selector: 'app-switch-language',
  templateUrl: './switch-language.component.html',
  styleUrls: ['./switch-language.component.scss']
})

export class SwitchLanguageComponent implements OnInit {

  constructor(public multiTenancyConfig: MultiTenancyConfigService,
    private interactService : InteractService) { }
  
  public languageSelected: string = this.multiTenancyConfig.currentLanguageSelected;
  public supportedLanguages: { [key: string]: any };


  ngOnInit() {
    this.supportedLanguages = this.multiTenancyConfig.supportedLanguages;
  }

  setLanguage(language: string) {
    if(this.languageSelected !== language){
      this.multiTenancyConfig.setLanguage(language);
      this.languageSelected = language;  
      this.interactService.refreshTranslateCall(language);
    }
    console.log(this.multiTenancyConfig.missingMasterTranslateLabelCd,"MISSING MASTER LABEL LIST");
    console.log(this.multiTenancyConfig.supportedLanguages[this.multiTenancyConfig.currentLanguageSelected].missingLabelTranslation,"MISSING TRANSLATION LIST");
  }

  fetchMissingLabel(){
    console.log(this.multiTenancyConfig.missingMasterTranslateLabelCd,"MISSING MASTER LABEL LIST");
    console.log(this.multiTenancyConfig.supportedLanguages[this.multiTenancyConfig.currentLanguageSelected].missingLabelTranslation,"MISSING TRANSLATION LIST");
  }

}
